import { createElement } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import BootstrapButtonGroup from '../bootstrap/ButtonGroup.js';
function ButtonGroup(_ref) {
  let {
    className,
    uiContext,
    ...rest
  } = _ref;
  return /*#__PURE__*/createElement(BootstrapButtonGroup, {
    className: clsx(className, {
      'btn-group-lean': uiContext === 'leanNav'
    }),
    ...rest
  });
}
export default ButtonGroup;